<template>
  <v-container class="pa-2">
    <!-- show ALL -->
    <div v-if="showFilter == 0 ">
      <v-layout row wrap>
        <v-flex xs12 class="pa-1">
          <v-select
            :items="Branch_List"
            label="สาขา"
            item-text="name"
            item-value="code"
            v-model="branchSelect"
            outline
            hide-details
          />
        </v-flex>
        <v-flex xs12 class="pa-1">
          <v-select
            class="ma-0"
            :items="Department_List"
            label="ฝ่าย"
            item-text="name"
            item-value="code"
            v-model="departmentSelect"
            outline
            hide-details
          />
        </v-flex>
        <v-flex xs12 class="pa-1">
          <v-select
            :items="Position_List"
            label="แผนก"
            item-text="name"
            item-value="code"
            v-model="positionSelect"
            outline
            hide-details
          />
        </v-flex>
      </v-layout>
      <v-divider class="my-2"/>
      <v-layout row wrap class="display_none1">
        <v-flex xs12 class="pa-1">
          <v-select
            :items="selectitems"
            :item-text="$t('txt')"
            item-value="val"
            :label="$t('duration')"
            v-model="ChoiceSelected"
            @change="selectChoice()"
          ></v-select>
        </v-flex>

        <v-flex xs12 class="pa-1">
          <v-text-field
            :label="$t('fromdate')"
            type="date"
            v-model="fromDateSelect"
            outline
            hide-details
            readonly
            @click="datedialog = false;onSelectDate()"
          />
        </v-flex>
        <v-flex xs12 class="pa-1">
          <v-text-field
            :label="$t('todate')"
            type="date"
            v-model="toDateSelect"
            outline
            hide-details
            readonly
            @click="datedialog = false;onSelectDate()"
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap class="display_none">
        <v-flex xs12 class="pa-1">
          <v-text-field
            :label="$t('fromdate')"
            type="date"
            v-model="fromDateSelect"
            outline
            hide-details
          />
        </v-flex>
        <v-flex xs12 class="pa-1">
          <v-text-field
            :label="$t('todate')"
            type="date"
            v-model="toDateSelect"
            outline
            hide-details
          />
        </v-flex>
      </v-layout>
    </div>
    <!-- show Date  -->
    <div v-if="showFilter == 1 ">
      <v-layout row wrap class="display_none1">
        <v-flex xs12 class="pa-1">
          <v-select
            :items="selectitems"
            :item-text="$t('txt')"
            item-value="val"
            :label="$t('duration')"
            v-model="ChoiceSelected"
            @change="selectChoice()"
          ></v-select>
        </v-flex>

        <v-flex xs12 class="pa-1">
          <v-text-field
            :label="$t('fromdate')"
            type="date"
            v-model="fromDateSelect"
            outline
            hide-details
            readonly
            @click="datedialog = false;onSelectDate()"
          />
        </v-flex>
        <v-flex xs12 class="pa-1">
          <v-text-field
            :label="$t('todate')"
            type="date"
            v-model="toDateSelect"
            outline
            hide-details
            readonly
            @click="datedialog = false;onSelectDate()"
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap class="display_none">
        <v-flex xs12 class="pa-1">
          <v-text-field
            :label="$t('fromdate')"
            type="date"
            v-model="fromDateSelect"
            outline
            hide-details
          />
        </v-flex>
        <v-flex xs12 class="pa-1">
          <v-text-field
            :label="$t('todate')"
            type="date"
            v-model="toDateSelect"
            outline
            hide-details
          />
        </v-flex>
      </v-layout>
    </div>
    <!-- show Select  -->
    <div v-if="showFilter == 2 ">
      <v-layout row wrap>
        <v-flex xs12 class="pa-1">
          <v-select
            :items="Branch_List"
            label="สาขา"
            item-text="name"
            item-value="code"
            v-model="branchSelect"
            outline
            hide-details
          />
        </v-flex>
        <v-flex xs12 class="pa-1">
          <v-select
            class="ma-0"
            :items="Department_List"
            label="ฝ่าย"
            item-text="name"
            item-value="code"
            v-model="departmentSelect"
            outline
            hide-details
          />
        </v-flex>
        <v-flex xs12 class="pa-1">
          <v-select
            :items="Position_List"
            label="แผนก"
            item-text="name"
            item-value="code"
            v-model="positionSelect"
            outline
            hide-details
          />
        </v-flex>
      </v-layout>
    </div>

    <!-- <v-divider class="my-2"/>
    <v-layout row wrap class="display_none1">
      <v-flex xs12 class="pa-1">
        <v-select
              :items="selectitems"
              :item-text="$t('txt')"
              item-value="val"
              :label="$t('duration')"
              v-model="ChoiceSelected"
              @change="selectChoice()"
            >
            </v-select>
      </v-flex>
       
      <v-flex xs12 class="pa-1">
        <v-text-field
          :label="$t('fromdate')"
          type="date"
          v-model="fromDateSelect"
          outline
          hide-details
          readonly
          @click="datedialog = false;onSelectDate()"
        />
      </v-flex>
      <v-flex xs12 class="pa-1">
        <v-text-field
          :label="$t('todate')"
          type="date"
          v-model="toDateSelect"
          outline
          hide-details
          readonly
          @click="datedialog = false;onSelectDate()"
        />
      </v-flex>
    </v-layout>
    <v-layout row wrap class="display_none">
      <v-flex xs12 class="pa-1">
        <v-text-field
         :label="$t('fromdate')"
          type="date"
          v-model="fromDateSelect"
          outline
          hide-details
          
        />
      </v-flex>
      <v-flex xs12 class="pa-1">
        <v-text-field
          :label="$t('todate')"
          type="date"
          v-model="toDateSelect"
          outline
          hide-details
          
        />
      </v-flex>
    </v-layout>-->

    <!-- FormEdit -->
    <v-layout row justify-center>
      <v-dialog v-model="datedialog" persistent max-width="650px">
        <v-card>
          <v-card-title>
            <span>กรุณาเลือกวันที่</span>
          </v-card-title>
          <v-card-text class="display_none1">
            <v-layout row wrap v-if="formatdate == 0">
              <v-flex xs12 sm6 md6 class="my-3">
                <span>{{$t('fromdate')}}</span>
                <v-date-picker v-model="fromDateSelect" locale="th"></v-date-picker>
              </v-flex>
              <v-flex xs12 sm6 md6 class="my-3">
                <span>{{$t('todate')}}</span>
                <v-date-picker v-model="toDateSelect" locale="th"></v-date-picker>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="formatdate == 1">
              <v-flex xs12 sm6 md6 class="my-3">
                <span>{{$t('fromdate')}}</span>
                <v-date-picker v-model="fromDateSelect" locale="en"></v-date-picker>
              </v-flex>
              <v-flex xs12 sm6 md6 class="my-3">
                <span>{{$t('todate')}}</span>
                <v-date-picker v-model="toDateSelect" locale="en"></v-date-picker>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="datedialog = false">Close</v-btn>
            <v-btn color="blue darken-1" flat @click="datedialog = false; SelectDate()">Select</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      datedialog: false,
      formatdate: 0,
      selectitems: [
        { txt: "None", val: "" },
        { txt: "ThisMount", val: 0 },
        { txt: "ThisWeek", val: 1 },
        { txt: "Today", val: 2 },
        { txt: "LastWeek", val: 3 },
        { txt: "LastMount", val: 4 }
      ],
      ChoiceSelected: ""
    };
  },
  computed: {
    ...mapGetters("filter", ["getShowFilter"]),
    ...mapState("app", ["formatDates"]),
    ...mapState("filter", [
      "loading",
      "Branch_List",
      "Department_List",
      "Position_List",
      "Errormsg",
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "FromDate",
      "ToDate",
      "showFilter"
    ]),
    branchSelect: {
      get() {
        return this.SelectBranch;
      },
      async set(value) {
        await this.getDepartment({ branch: value });
      }
    },
    departmentSelect: {
      get() {
        return this.SelectDepartment;
      },
      async set(value) {
        await this.getPosition({ department: value });
      }
    },
    positionSelect: {
      get() {
        return this.SelectPosition;
      },
      async set(value) {
        await this.selectedPosition({ data: value });
      }
    },
    fromDateSelect: {
      get() {
        return this.FromDate;
      },
      async set(value) {
        await this.selectedFormDate({ data: value });
      }
    },
    toDateSelect: {
      get() {
        return this.ToDate;
      },
      async set(value) {
        await this.selectedToDate({ data: value });
      }
    }
  },
  mounted: function() {
    if (this.Branch_List.length == 0) {
      this.getBranch();
    }
  },
  methods: {
    ...mapActions("filter", ["getBranch", "getDepartment", "getPosition"]),
    ...mapActions("app", ["getFormatDate"]),
    ...mapMutations("filter", [
      "selectedPosition",
      "selectedFormDate",
      "selectedToDate"
    ]),
    onSelectDate() {
      this.datedialog = true;
    },
    SelectDate() {
      console.log(this.selectdatadate);
    },
    _today() {
      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();

      var output =
        d.getFullYear() +
        "-" +
        (month < 10 ? "0" : "") +
        month +
        "-" +
        (day < 10 ? "0" : "") +
        day;

      return output;
    },
    _docdate() {
      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = d.getHours();
      var min = d.getMinutes();

      var output =
        d.getFullYear() +
        "" +
        (month < 10 ? "0" : "") +
        month +
        "" +
        (day < 10 ? "0" : "") +
        day +
        hour +
        min;

      return output;
    },
    selectChoice() {
      console.log(this.ChoiceSelected);
      if (this.ChoiceSelected == 0) {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.fromDateSelect = this.selectedformatDate(firstDay);
        this.toDateSelect = this.selectedformatDate(lastDay);
      } else if (this.ChoiceSelected == 1) {
        var curr = new Date();
        var first = curr.getDate() - curr.getDay();
        var last = first + 6;
        var firstday = new Date(curr.setDate(first)).toUTCString();
        var lastday = new Date(curr.setDate(last)).toUTCString();
        this.fromDateSelect = this.selectedformatDate(firstday);
        this.toDateSelect = this.selectedformatDate(lastday);
      } else if (this.ChoiceSelected == 2) {
        var curr = new Date();
        this.fromDateSelect = this.selectedformatDate(curr);
        this.toDateSelect = this.selectedformatDate(curr);
      } else if (this.ChoiceSelected == 3) {
        var curr = new Date();  
        var first = curr.getDate() - curr.getDay();
        var last = first - 6;
        var firstday = new Date(curr.setDate(first)).toUTCString();
        var lastday = new Date(curr.setDate(last)).toUTCString();
       if(curr.setDate(first) > curr.setDate(last)){
          this.from_date = this.selectedformatDate(lastday);
          this.to_date = this.selectedformatDate(firstday);
        }else if(curr.setDate(first) < curr.setDate(last)){
          this.from_date = this.selectedformatDate(firstday);
          this.to_date = this.selectedformatDate(lastday);
        }
       
      } else if (this.ChoiceSelected == 4) {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth(), 0);
        this.fromDateSelect = this.selectedformatDate(firstDay);
        this.toDateSelect = this.selectedformatDate(lastDay);
      } else {
        this.fromDateSelect = "";
        this.toDateSelect = "";
      }
    },
    selectedformatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    }
  },
  created: function() {
    this.formatdate = this.formatDates;

  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

h2,
span,
p {
  font-family: "Prompt", sans-serif;
}

/* mobile  ----------- */
@media screen and (min-width: 320px) and (max-width: 640px) {
  #header_message {
    visibility: hidden;
    clear: both;
    float: left;
    width: 28%;
    display: none;
    margin-right: 0px !important;
  }
  .container-fluid {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* tablet  ----------- */
@media screen and (max-width: 768px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* ipad pro  ----------- */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: none;
  }
}

@media screen and (min-width: 1024px) and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: none;
  }
}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
</style>

